/* eslint-disable react-hooks/exhaustive-deps */
import { Card, CardBody, CardHeader } from "reactstrap";
import moment from "moment";
import { useFormik } from "formik";
import { ProyeccionDiariaFilter } from "../components/Proyeccion.Diaria.Filter";
import { useProyeccionDiaria } from "../hooks/useProyeccionDiaria";
import { useEffect, useState } from "react";
import { ProyeccionDiariaTable } from "../components/Proyeccion.Diaria.Table";
import Swal from "sweetalert2";
import { useBitacoraNotificaciones } from "../hooks/useBitacoraNotificaciones";
import axios from "axios";

const initialFaluesFilter = {
  cultivo: "",
  fecha: moment().add(1, "day").format("YYYY-MM-DD"),
};

export const ProyeccionDiaria = () => {
  const { getNotificacion } = useBitacoraNotificaciones();
  const { getProyeccion, isProyeccionLoading, saveProyeccion } =
    useProyeccionDiaria();
  const [data, setData] = useState([]);
  const [idNotificacion, setIdNotificacion] = useState(null);
  const [notificationMessage, setNotificationMessage] = useState("");
  const handleSubmitFilterForm = () => {};

  const validatePercentages = () => {
    const invalidVarieties = [];
    for (const item of data.filter(
      (item) => item.total !== "" && item.total !== 0,
    )) {
      const totalPercentage = item.tamanios.reduce(
        (sum, tamanio) => sum + Number(tamanio.porcentaje),
        0,
      );
      if (totalPercentage < 100) {
        invalidVarieties.push(item.variedad);
      }
    }
    return invalidVarieties;
  };

  const handleGuardarProyeccionDiaria = async () => {
    const validate_total_porcentaje = validatePercentages();
    if (validate_total_porcentaje.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Porcentajes no alcanzados",
        text: `No se alcanzo el 100% en las variedades ${validate_total_porcentaje.join(
          ", ",
        )}`,
      });
      return;
    }
    try {
      await saveProyeccion(
        filterForm.values.fecha,
        data.filter((item) => ![0, "", "0", null].includes(item.total)),
      );
      getProyeccionDiaria();
      getIdNotificacion();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Algo salio mal",
            text: `error: ${error.response.data.msg}`,
          });
          return;
        }
      }
      Swal.fire({
        icon: "error",
        title: "Algo salio mal",
        text: `error: ${error.response.data}`,
      });
      console.log(error);
    }
  };

  const getIdNotificacion = async () => {
    const response = await getNotificacion(filterForm.values.fecha);
    setIdNotificacion(response.id);
    setNotificationMessage(response?.msg ?? "");
  };

  const filterForm = useFormik({
    onSubmit: handleSubmitFilterForm,
    initialValues: initialFaluesFilter,
  });

  const getProyeccionDiaria = async () => {
    const { values } = filterForm;
    const response = await getProyeccion(values.fecha, values.cultivo);
    setData(response);
  };

  useEffect(() => {
    if (filterForm.values.cultivo !== "" && filterForm.values.fecha !== "") {
      getProyeccionDiaria();
    }
  }, [filterForm.values]);

  useEffect(() => {
    const { values } = filterForm;
    if (values.fecha && values.fecha !== "") {
      getIdNotificacion();
    }
  }, [filterForm.values.fecha]);

  return (
    <section>
      <Card className="my-2">
        <CardHeader>Proyección diaria</CardHeader>
        <CardBody>
          <ProyeccionDiariaFilter
            values={filterForm.values}
            handleChange={filterForm.handleChange}
            setFieldValue={filterForm.setFieldValue}
            loading={isProyeccionLoading}
            onSubmit={handleGuardarProyeccionDiaria}
            idNotificacion={idNotificacion}
            mensaje={notificationMessage}
            refrechNotificationOnSend={getIdNotificacion}
          />
          <br />
          <ProyeccionDiariaTable
            id_cultivo={filterForm.values.cultivo}
            data={data}
            setData={setData}
            fecha={filterForm.values.fecha}
            onReload={getProyeccionDiaria}
          />
        </CardBody>
      </Card>
    </section>
  );
};
